export default [
  {
    path: 'hk/course/:courseId',
    name: 'general',
    component: () => import('@/views/learning/course/General.vue'),
  },
  {
    path: 'en/course/:courseId',
    name: 'english',
    component: () => import('@/views/learning/course/Recite.vue'),
  },
  {
    path: 'cn/course/:courseId',
    name: 'chinese',
    component: () => import('@/views/learning/course/Chinese.vue'),
  },
];
